import { getSelectedElements } from '../../selection/selectedElementsSelector';
import { getLocationSection, isElementLocked } from '../../../../common/elements/utils/elementPropertyUtils';
import { BoardSections } from '../../../../common/boards/boardConstants';
import { toArray } from '../../../../common/utils/immutableHelper';

export const selectIsResizeInProgress = (state) => state.getIn(['app', 'resizing', 'isResizeInProgress']);

export const selectResizingElementIds = (state) => {
    const resizingElements = selectElementResizingValues(state);
    return Object.keys(resizingElements?.toJS());
};

export const selectResizableElementsGroup = (state) =>
    getSelectedElements(state).filter(
        (element) => getLocationSection(element) === BoardSections.CANVAS && !isElementLocked(element),
    );

export const selectIsCurrentElementMultiResizing = (elementId) => (state) =>
    selectIsResizingElement(elementId)(state) && selectResizingElementIds(state).length > 1;

export const selectElementResizingValues = (state) => state.getIn(['app', 'resizing', 'resizingElements']);

// For performance, we want most of these resizing selectors to return early
// if they're being run for an element that isn't currently being resized.
const createCurrentElementResizingSelector =
    (selector, nonResizingValue = null) =>
    (elementId) =>
    (state) => {
        if (!selectResizingElementIds(state)?.includes(elementId)) return nonResizingValue;

        return selector(state);
    };

// Inlining this one's logic into the main function means we can skip creating a new callback for every check.
export const selectIsResizingElement = createCurrentElementResizingSelector(() => true, false);

export const selectResizeScale = createCurrentElementResizingSelector((state) =>
    state.getIn(['app', 'resizing', 'scale']),
);

export const selectDragOrigin = createCurrentElementResizingSelector((state) =>
    state.getIn(['app', 'resizing', 'origin']),
);

export const selectGroupLockAspectRatio = createCurrentElementResizingSelector((state) => {
    const resizingValues = selectElementResizingValues(state).toJS();
    return toArray(Object.values(resizingValues)).some((e) => e.lockAspectRatio);
});

export const selectGroupMinScales = createCurrentElementResizingSelector((state) => {
    const resizingValues = selectElementResizingValues(state).toJS();
    const scales = toArray(Object.values(resizingValues)).map((e) => e.minResizeScale);
    if (scales.length === 0) return null;

    const minScaleX = scales.reduce((val, scale) => Math.max(val, scale?.x || 0), 0);
    const minScaleY = scales.reduce((val, scale) => Math.max(val, scale?.y || 0), 0);
    return { x: minScaleX, y: minScaleY };
});

export const selectAllowChangingAspectRatio = createCurrentElementResizingSelector((state) =>
    state.getIn(['app', 'resizing', 'allowChangingAspectRatio']),
);
